import "@fontsource/nunito";
import { trackGooglePageView } from "./src/util/cookieConsent";

export const onRouteUpdate = ({ location }) => {
  document.querySelector("#page-loader").style["display"] = "none";
  trackGooglePageView(location.pathname + location.search);
};
